// extracted by mini-css-extract-plugin
module.exports = {"modal-left-section":"quote-info-modal__modal-left-section___1wGZ8","done-button":"quote-info-modal__done-button___tPOoe"};